export default __webpack_public_path__ + "static/media/6-web-front-end.43087088.webp";